import { M_PER_NEW_02_Schema } from './M_PER_NEW_02_Schema';
import { mapParamsBySchema } from '../../../../util';
import Global from '../../../../Services/Common/Global';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import useSearchMutaion from '../../../../Hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';
import useDeleteMutation from '../../../../Hooks/apis/useDeleteMutaion';

export const useSearch1 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_PER_NEW_02_Schema.mapper.search1,
      context
    );
    return apiRequest('post', Global.urls.Permit.getPerNewR3, params);
  }, successOptions);
};

export const useSave1 = () =>
  useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(
      M_PER_NEW_02_Schema.mapper.save1,
      context
    );

    return apiRequest('post1', Global.urls.Permit.savePerNewU3, payload);
  });
export const useSave2 = () =>
  useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(
      M_PER_NEW_02_Schema.mapper.save2,
      context
    );

    return apiRequest('post1', Global.urls.Permit.savePerNewU4, payload);
  });

export const useSave6 = () =>
  useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(
      M_PER_NEW_02_Schema.mapper.save6,
      context
    );
    return apiRequest('post1', Global.urls.Permit.savePerNewU6, payload);
  });

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (context) => {
    const payload = mapParamsBySchema(
      M_PER_NEW_02_Schema.mapper.delete1,
      context
    );
    return apiRequest('post', Global.urls.Permit.deletePerNewD1, payload);
  }, options);
};
